const logoutUser = async ({ token }) => {
  try {
    const response = await fetch(
      "https://lvdmsup.nablasol.net/DMS/api/logout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export default logoutUser;
